export default __webpack_public_path__ + "static/media/yellow_base.754e4597.png";